// @flow

import styled, { css } from "styled-components";
import { generateTransition, easeInOut } from "@fdr/static-ui/Transitions";
import { fontBold, fontCondensed, fontNormal } from "@fdr/static-ui/Typography";
import buildColor from "@fdr/static-ui/ColorPalette";

export const ListHolder = styled.div`
  border-top: 1px solid ${buildColor("grey", "L2")};
  ${(props) =>
    !props.paddingless &&
    css`
      padding: 8px 8px 0 8px;
    `};
  ${(props) =>
    props.paddingBottom &&
    css`
      padding: 8px;
    `};
  background-color: ${buildColor("white", "100")};

  & > div:first-child {
    height: auto;
  }

  & > button:last-child {
    display: flex;
    align-items: center;
    position: fixed;
    left: 12px;
    bottom: 12px;
    font-family: ${fontBold};

    > svg {
      margin-right: 8px;
    }
  }

  &.expandable {
    overflow: hidden;
    transition: ${generateTransition(easeInOut, "max-height")};

    &.expand-inside-enter {
      max-height: 95px;
    }

    &.expand-inside-enter-active {
      max-height: 500px;
    }

    &.expand-inside-enter-done {
      max-height: 500px;
    }
  }
`;

export const ListWrapper = styled.div`
  background-color: ${buildColor("white", "100")};
  ${(props) =>
    !props.borderless &&
    css`
      border: 1px solid ${buildColor("grey", "300")};
      border-radius: 2px;
    `};
`;

export const MatchHolder = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  height: 47px;
  padding: 0 16px;
  background-color: ${buildColor("white", "100")};
  border-bottom: 1px solid ${buildColor("grey", "L2")};
  border-top: 1px solid ${buildColor("grey", "L2")};

  & > span {
    color: ${buildColor("navy", "700")};
    font-family: ${fontNormal};
    font-size: 14px;
  }
`;

export const EmptyStateContainer = styled.div`
  height: 48px;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const IconContainer = styled.div`
  padding-left: 3px;
  height: 16px;
`;

export const ListHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background-color: ${buildColor("grey", "100")};
  border-bottom: 1px solid ${buildColor("grey", "300")};
  text-transform: uppercase;
  height: 32px;
  color: ${buildColor("grey", "800")};
  font-family: ${fontCondensed};
  font-size: 12px;
  letter-spacing: 1px;
  ${(props) =>
    props.hasBorderTop &&
    css`
      border-top: 1px solid ${buildColor("grey", "L2")};
    `}
`;
